import * as React from 'react'
import MUIListItemText from '@mui/material/ListItemText'

const ListItemText = (props) => <MUIListItemText {...props} />

export default ListItemText
